import React from 'react';

import moment from 'moment';

interface ProfileDateHeaderProps {
  date: string;
}

const ProfileDateHeader = ({ date }: ProfileDateHeaderProps) => {
  return (
    <h4 className="offcanvas-title">{moment(date).format('DD MMM YYYY')}</h4>
  );
};

export default ProfileDateHeader;
